/* DowcPickerRenderer.js */

"use strict";
const ComboBoxControl = require("@gluenetworks/combobox").Single;
const BaseScheduleRenderer = require("../../base/BaseScheduleRenderer");
const RendererUtils = require("../../base/RendererUtils");
const DowComponent = require("../../common_components/dow_picker_component/DowPickerComponent");
const MoyComponent = require("../../common_components/moy_picker_component/MoyPickerComponent");

const DaysOfWeekCountOptions = [
    {label: "first", value: 1},
    {label: "second", value: 2},
    {label: "third", value: 3},
    {label: "fourth", value: 4},
    {label: "last", value: 0},
];

class DowcPickerRenderer extends BaseScheduleRenderer {
    constructor(model) {
        super(model);
    }
    render(formContainerElem) {
        if (this.isRendered()) {
            return Promise.resolve();
        }
        return Promise.resolve()
            .then(() => {
                let includeMoy = this._model.getSchedule().type === "dowomoy";
                this._dowcComp = new ComboBoxControl({
                    options: DaysOfWeekCountOptions,
                    showFilter: false,
                    adjustWidth: true,
                });
                this._dowComp = new DowComponent(this._model);
                this._moyComp = new MoyComponent(this._model);
                this._parts = RendererUtils.groupGridRowElements(
                    formContainerElem,
                    "on-the",
                    "On the",
                    this._dowcComp,
                    this._dowComp,
                    includeMoy ? "of" : "of the month",
                    includeMoy ? this._moyComp : null
                );
                return Promise.all([
                    this._dowcComp.renderer.render(),
                    this._dowComp.renderer.render(),
                    this._moyComp.renderer.render(),
                ]);
            })
            .then(() => {
                this._setTheme(this._model.theme);
                this._registerListeners();
                this.setRendered(true);
            });
    }
    getParts() {
        return this._parts;
    }
    shutdown() {
        if (!this.isRendered()) {
            return Promise.resolve();
        }
        return Promise.resolve()
            .then(() => {
                this._unregisterListeners();
                return Promise.all([
                    super.shutdown(),
                    this._dowcComp.shutdown(),
                    this._dowComp.shutdown(),
                    this._moyComp.shutdown(),
                ]);
            })
            .then(() => {
                this._parts = undefined;
                this._dowcComp = undefined;
                this._dowComp = undefined;
                this._moyComp = undefined;
            })
            .catch((err) => {
                console.error(err);
            });
    }
    _registerListeners() {
        super._registerListeners();
        this._dowcComp.on("UserValue", (this._onDowc = this._onDowc.bind(this)));
    }
    _unregisterListeners() {
        super._unregisterListeners();
        this._dowcComp.removeListener("UserValue", this._onDowc);
    }
    _onDowc() {
        this._model.setScheduleProp("dowc", this._dowcComp.getValue(), true);
    }
    _setControlValuesFromModel() {
        this._dowcComp.setValue(this._model.getScheduleProp("dowc"));
    }
}
module.exports = DowcPickerRenderer;
